import React from 'react'

export interface TimePeriodSeriesProps {
  label: string
  selected: boolean
  onTimePeriodSelected: () => void
}

const TimePeriodSeriesLabel = ({
  selected,
  label = '',
  onTimePeriodSelected = () => {},
}: TimePeriodSeriesProps) => {
  return (
    <div className="z-10">
      <div className="text-13px cursor-pointer font-normal">
        <p
          className={`${
            selected
              ? ' text-brand-blue-azureRadiance rounded-3xl px-3 py-0.5 font-medium'
              : 'px-2 py-0.5 text-gray-600 md:px-3'
          } `}
          onClick={() => {
            if (!selected) {
              onTimePeriodSelected()
            }
          }}
        >
          {label}
        </p>
      </div>
    </div>
  )
}

export default React.memo(TimePeriodSeriesLabel)
